import type { MetricsInfo } from 'owa-calendar-compose-types';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    FullComposeEntrySourceType,
    FULL_COMPOSE_ENTRY_SOURCE_QUICK_COMPOSE,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import cloneEvent from 'owa-calendar-forms-common/lib/utils/cloneEvent';
import isEntrySourceUndo from './isEntrySourceUndo';

export default function createFullComposeMetricsInfo(
    initialMetrics: MetricsInfo | null,
    event: CalendarEvent,
    entrySource: FullComposeEntrySourceType,
    extractionSourceId?: string | null
): MetricsInfo {
    let metricsInfo = { ...initialMetrics };

    // Take a snapshot of the final event in quick compose
    if (entrySource === 'QuickCompose') {
        metricsInfo.quickComposeFinalEvent = cloneEvent(event);
    }

    if (entrySource === 'Mail_SmartReplyWithMeeting') {
        metricsInfo.extractionSourceId = extractionSourceId;
    }

    metricsInfo.fullComposeEntrySource = entrySource;

    if (!isEntrySourceUndo(entrySource) && entrySource != FULL_COMPOSE_ENTRY_SOURCE_QUICK_COMPOSE) {
        // If it is not the undo scenario and it's not the transition from quick compose scenario,
        // then we want to not log the quickComposeEntrySource that was set in the previous session
        metricsInfo.quickComposeEntrySource = undefined;
    }

    return metricsInfo;
}
